import { useLocation } from "react-router-dom";
import { useAppSelector } from "../../../hooks/useAppSelector";

const InfoLoja = () => {
  const { pathname } = useLocation();

  const lojas = useAppSelector((state) => state.getLojas.lojas);
  const lojaSelected = useAppSelector((state) => state.getLojas.lojaSelected);

  const lojaSelectedInfo: any = lojas.filter(
    ({ id }) => id === Number(lojaSelected)
  )[0];

  if (pathname.search("pontos-de-monitoria") === -1) return null;

  return (
    <div className="info-loja">
      {lojaSelectedInfo && (
        <>
          <h2 className="heading--sm color-primary">
            Loja {lojaSelectedInfo?.numero} - {lojaSelectedInfo?.nome}{" "}
            {lojaSelectedInfo?.uf}
          </h2>
          <p className="paragraph--sm color-secondary">
            {lojaSelectedInfo?.endereco}
          </p>
        </>
      )}
    </div>
  );
};

export default InfoLoja;
